import React, { Component } from "react";
import { Icon } from "office-ui-fabric-react/lib/Icon";
import { IconButton, ActionButton } from "office-ui-fabric-react/lib/Button";
import TablesSwitchButton from '../../common/Buttons/_TablesSwitchButton'

export const _columns = [
  {
    key: "storagesByShipmentId.nodes",
    name: "File",
    isIconOnly: false,
    fieldName: "storagesByShipmentId.nodes",
    minWidth: 20,
    maxWidth: 30,
    isPadded: false,
    onRender: item => {
      return (
        <div>
          {item.storagesByShipmentId && item.storagesByShipmentId.nodes.length > 0 ? (
            <div>
              <Icon iconName="Attach" />
              {item.storagesByShipmentId.nodes.length}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    },
  },

  {
    key: "date",
    name: "Loading date",
    fieldName: "date",
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.date}</div>;
    },
  },
  {
    key: "relationByRelationId.name",
    name: "Shipper",
    fieldName: "relationByRelationId.name",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.relationByRelationId.name}</div>;
    },
  },
  {
    key: "carrierByCarrierId.truck",
    name: "Truck",
    fieldName: "carrierByCarrierId.truck",
    minWidth: 100,
    maxWidth: 170,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.carrierByCarrierId.truck}</div>;
    },
  },
  {
    key: "carrierByCarrierId.trailer",
    name: "Trailer",
    fieldName: "carrierByCarrierId.trailer",
    minWidth: 100,
    maxWidth: 170,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.carrierByCarrierId.trailer}</div>;
    },
  },
  {
    key: "cargoTypeByCargoTypeId.type",
    name: "Cargo type",
    fieldName: "cargoTypeByCargoTypeId.type",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.cargoTypeByCargoTypeId.type}</div>;
    },
  },
  {
    key: "about",
    name: "Info",
    fieldName: "about",
    minWidth: 170,
    maxWidth: 250,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
  },
  {
    key: "cargoTypeByCargoTypeId.type",
    name: "To orders",
    fieldName: "cargoTypeByCargoTypeId.type",
    minWidth: 50,
    maxWidth: 60,
    onRender: item => {
      return (
        <TablesSwitchButton componentType='toOrder'/>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentTableColumns.js